mainApp.component('uploadLog',{
    templateUrl: '/public/components/upload-log.component.html',
    bindings: {
        vpnClientPolicy: '=',
        changesListener: '&'
    },
    controller: uploadLogController
});


function uploadLogController($scope, $state){
    let $ctrl = this;

    $ctrl.isSystemLogin = isSystemLogin;
    $ctrl.logLevels = ['Info','Debug','Trace', 'Warn','Error'];

    $ctrl.$onInit = function() {
        reload();
    }

    $scope.$on('modelReloadedEvent', function (event, data) {
        reload();
    });

    $ctrl.onChangeUploadFlag = function (){
        console.log()
        $ctrl.onChange(!angular.equals($ctrl.uploadLog, $ctrl.uplaodFlagOrigin))
        $ctrl.vpnClientPolicy.uploadLog = $ctrl.uploadLog;
    }
    $ctrl.onChangeLogLevel = function (){
        $ctrl.onChange(!angular.equals($ctrl.currentLogLevel, $ctrl.logLevelOrigin))
        $ctrl.vpnClientPolicy.logLevel = $ctrl.currentLogLevel;
    }

    $ctrl.onChangeUploadInterval = function (){
        $ctrl.onChange(!angular.equals($ctrl.uploadInterval, $ctrl.uploadIntervalOrigin))
        $ctrl.vpnClientPolicy.uploadLogInterval = $ctrl.uploadInterval;
    }

    $ctrl.onChange = function(isChanged){
        $ctrl.changesListener({isDirty: isChanged, componentName: 'uploadLog'});

    }

    function reload() {

        $ctrl.uplaodFlagOrigin = angular.copy($ctrl.vpnClientPolicy.uploadLog);
        $ctrl.uploadIntervalOrigin = angular.copy($ctrl.vpnClientPolicy.uploadLogInterval);
        $ctrl.logLevelOrigin = angular.copy($ctrl.vpnClientPolicy.logLevel);
        $ctrl.currentLogLevel = $ctrl.vpnClientPolicy.logLevel;
        $ctrl.uploadInterval = $ctrl.vpnClientPolicy.uploadLogInterval;
        $ctrl.uploadLog = $ctrl.vpnClientPolicy.uploadLog;
        $ctrl.changesListener({isDirty: false, componentName: 'uploadLog'});
    }

}
